// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"180":"a8ee6ca9","820":"80b2151c"}[chunkId] + ".chunk.css");